import React, { useEffect, useState } from "react";
import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  styled,
} from "@mui/material";
import { useSnackbar } from "notistack";
import PhoneInput from "react-phone-number-validation";
import FormInput from "../../components/GeneralComponents/FormInput";
import { useAdminContext } from "../../Hooks/AdminContext";
import BasicBreadcrumbs from "../../components/GeneralComponents/BreadCrumbs";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Add_Business_Center,
  Get_Business_Center_Byid,
  Update_Business_Center,
} from "../../DAL/Listing/BusinessCenter";
import CustomCircularProgress from "../../components/CustomCircularProgress";
import { isValidPhoneNumber } from "libphonenumber-js";
import { uploadImage } from "../../utils/constant";
import { picBaseUrl } from "../../config/config";

const Input = styled("input")({
  display: "none",
});

export const AddOrUpdateBusinessCenter = ({ type }) => {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [phoneNumber, setPhoneNumber] = useState("");
  const navigate = useNavigate();
  const [file, setProfileImage] = useState();
  const params = useParams();
  const { state } = useLocation();
  const { setnavbarTitle } = useAdminContext();
  let isValid = phoneNumber === "" || isValidPhoneNumber(phoneNumber);
  const [localInput, setLocalInput] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    company_name: "",
    street_address: "",
    city: "",
    state: "",
    country: "",
    postal_code: "",
    image: "",
    status: true,
    top_up_fee: "",
    affiliate_commission: "",
  });

  // Handle change in the phone number input
  const handlePhoneChange = (value, country) => {
    setPhoneNumber(value);
  };

  // Handle change in the input fields
  const handleChange = (e, name) => {
    setLocalInput({ ...localInput, [name]: e.target.value });
  };

  // Handles profile image upload: validates type and updates preview & state
  const fileChangedHandler = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    // Allowed image types
    const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      enqueueSnackbar("Only JPG, JPEG, PNG, and WEBP files are allowed.", {
        variant: "error",
      });
      return;
    }

    // If valid, update state
    setProfileImage(URL.createObjectURL(file));
    setLocalInput({
      ...localInput,
      ["image"]: file,
    });
  };

  // Handles form submission: validates, uploads image if needed, then adds/updates business center
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!isValid) {
      enqueueSnackbar("Please enter a valid phone number", {
        variant: "error",
      });
      setLoading(false);
      return;
    }

    let imagePath = localInput.image;

    if (localInput.image && typeof localInput.image !== "string") {
      const uploadedPath = await uploadImage(localInput.image);
      if (!uploadedPath) {
        setLoading(false);
        return; // Stop execution if upload fails
      }
      imagePath = uploadedPath;
    }

    const formData = {
      name: localInput?.name,
      // email: localInput?.email,
      status: localInput?.status,
      // contact_number: phoneNumber,
      // image: imagePath,
    };

    const response =
      type === "add"
        ? await Add_Business_Center(formData)
        : await Update_Business_Center(formData, params.id);

    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      setLoading(false);
      if (!loading) {
        navigate("/business-center");
      }
    } else {
      setLoading(false);
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  // Breadcrumb navigation for Add/Edit Business Center page
  const BreadCrumbsList = [
    {
      title: "Business Center Management",
      navigation: "/business-center",
      active: false,
    },
    {
      title: `${params.id ? "Edit" : "Add"} Business Center`,
      navigation: "",
      status: "Active",
    },
  ];

  // Fetch and set business center data by ID for editing
  const GetBusinessCenter = async () => {
    setLoading(true);
    const response = await Get_Business_Center_Byid(params.id);
    if (response.code === 200) {
      setLocalInput({
        ...response.business_center,
        // phone: response.business_center.contact_number,
        // image: response.business_center.image,
      });
      // setPhoneNumber(response.business_center.contact_number);
      setLoading(false);
    } else {
      setLoading(false);
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  // Initialize form state from navigation state or fetch data by ID, and set navbar title
  useEffect(() => {
    if (state) {
      setLocalInput({
        ...state,
        // email: state?.email,
        // country: state?.country,
        // street_address: state?.street,
        // image: state?.image,
      });
      // setPhoneNumber(state?.contact_number);
    } else if (params.id && !state) {
      GetBusinessCenter();
    }
    setnavbarTitle("Business Center Management");
  }, [state]);

  if (loading) {
    return <CustomCircularProgress />;
  }
  return (
    <div className="container-fluid">
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-12 mb-3">
            <BasicBreadcrumbs items={BreadCrumbsList} />
          </div>
          <div className="col-md-6 mt-2">
            <FormInput
              fullWidth
              label="Name"
              type="text"
              variant="outlined"
              value={localInput.name}
              onChange={(e) => handleChange(e, "name")}
              required
            />
          </div>
          {/* <div className="col-md-6 mt-2">
            <FormInput
              fullWidth
              label="Company Name"
              variant="outlined"
              value={localInput?.company_name}
              onChange={(e) => handleChange(e, "company_name")}
              required
            />
          </div> */}
          {/* <div className="col-md-6 mt-2">
            <FormInput
              fullWidth
              label="Email"
              type="email"
              variant="outlined"
              value={localInput.email}
              onChange={(e) => handleChange(e, "email")}
              required
            />
          </div> */}
          {/* <div className="col-md-6 mt-2">
            <TextField
              fullWidth
              label="Password"
              variant="outlined"
              value={localInput.password}
              onChange={(e) => handleChange(e, "password")}
              type={showPassword ? "text" : "password"}
              required
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={togglePasswordVisibility} edge="end">
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div> */}
          {/* <div className="col-md-6 mt-2">
            <PhoneInput
              enableSearch={true}
              autoSelectCountry={true}
              countryCodeEditable={false}
              country="pk"
              value={phoneNumber}
              setValue={setPhoneNumber}
              onChange={handlePhoneChange}
              onRender={(value, country) => {
                setPhoneNumber(value);
              }}
            />
          </div> */}
          <div className="col-md-6 mt-3">
            <FormControl fullWidth required>
              <InputLabel>Status</InputLabel>
              <Select
                value={localInput?.status}
                onChange={(e) => handleChange(e, "status")}
                label="Status"
              >
                <MenuItem value={true}>Active</MenuItem>
                <MenuItem value={false}>Inactive</MenuItem>
              </Select>
            </FormControl>
          </div>
          {/* <div className="col-md-6 mt-3">
            <FormControl fullWidth required>
              <InputLabel htmlFor="outlined-adornment-amount">
                Top Up Fee
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-amount"
                value={localInput?.top_up_fee}
                type="number"
                onChange={handleChange}
                name="top_up_fee"
                endAdornment={<InputAdornment position="end">%</InputAdornment>}
                label="Top Up Fee"
              />
            </FormControl>
          </div>
          <div className="col-md-6 mt-3">
            <FormControl fullWidth required>
              <InputLabel htmlFor="outlined-adornment-amount">
                Affiliate Commission
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-amount"
                value={localInput?.affiliate_commission}
                type="number"
                onChange={handleChange}
                name="affiliate_commission"
                endAdornment={<InputAdornment position="end">%</InputAdornment>}
                label="Affiliate Commission"
              />
            </FormControl>
          </div> */}
          {/* <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
            <div className="row w-100 div-style ms-0 pt-0">
              <div className="col-lg-5 col-md-5 col-sm-12">
                <p className="">Upload Image</p>
                <FormHelperText className="pt-0 text-muted">
                  Image Size(300 X 300) ("JPG", "JPEG", "PNG","WEBP")
                </FormHelperText>
              </div>
              <div className="col-lg-2 col-md-2 col-6">
                {file ? (
                  <img className="image-border" src={file} height="50" />
                ) : (
                  <>
                    {localInput.image && (
                      <img
                        className="image-border"
                        src={picBaseUrl + localInput.image}
                        height="50"
                      />
                    )}
                  </>
                )}
              </div>
              <div className="col-lg-5 col-md-5 col-6 text-end pt-2">
                <label htmlFor="contained-button-file">
                  <Input
                    accept="image/*"
                    id="contained-button-file"
                    multiple={false}
                    type="file"
                    name="image"
                    onChange={fileChangedHandler}
                  />

                  <Button
                    className="small-contained-button"
                    startIcon={
                      <FileUploadIcon
                        style={{
                          fill: "#fff",
                        }}
                      />
                    }
                    component="span"
                  >
                    Upload
                  </Button>
                </label>
              </div>
            </div>
            {localInput?.image?.name && (
              <p className="text-secondary mb-0">{localInput?.image?.name}</p>
            )}
          </div> */}
          {/* <div className="col-md-6 mt-2">
            <FormInput
              fullWidth
              label="Street Address"
              variant="outlined"
              value={localInput?.street_address}
              onChange={(e) => handleChange(e, "street_address")}
              required
            />
          </div>
          <div className="col-md-6 mt-2">
            <FormInput
              fullWidth
              label="City"
              variant="outlined"
              value={localInput?.city}
              onChange={(e) => handleChange(e, "city")}
              required
            />
          </div>
          <div className="col-md-6 mt-2">
            <FormInput
              fullWidth
              label="State/Province"
              variant="outlined"
              value={localInput?.state}
              onChange={(e) => handleChange(e, "state")}
              required
            />
          </div>
          <div className="col-md-6">
            <FormInput
              fullWidth
              label="Postal Code"
              variant="outlined"
              type="number"
              value={localInput?.postal_code}
              onChange={(e) => handleChange(e, "postal_code")}
              required
            />
          </div>
          <div className="col-md-6">
            <FormInput
              fullWidth
              label="Country"
              variant="outlined"
              value={localInput?.country}
              onChange={(e) => handleChange(e, "country")}
              required
            />
          </div> */}
          <div className="col-md-12 mt-3 text-end">
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={loading}
              className="small-contained-button"
            >
              {params.id ? "Update" : "Submit"}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};
